/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
import { useSelector, useDispatch } from "react-redux";
import { BudgetItem, CurrentUser, DateTime, FamilyHasAccess, TransactionItem, UserItem } from "../types";
import { useItems } from "../features/Fetch/Items";
import { Grid, Card, CardHeader, CardContent, Button, List, ListItemButton, ListItemIcon, ListItemText, Divider, Box, Typography, Stack } from "@mui/material";
import { FileEarmarkSpreadsheetFill } from "react-bootstrap-icons";
import { ModalProps, setProps } from "../features/Slices/modalSlice";
import { useNavigate } from "react-router-dom";
import ExpensesReport from "../components/Modals/ExpensesReport";
import UserReport from "../components/Modals/UserReport";
import { Features } from "../constants";
import { SavedReport } from "../features/Slices/savedReportsSlice";
import dayjs from "dayjs";

const Reports = () => {
	const repo = useItems();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const isMobile: boolean = useSelector((state: any) => state.isMobile.value);
	const user: CurrentUser = useSelector((state: any) => state.userData.value);
	const modal: ModalProps = useSelector((state: any) => state.modal.value);

	const transactions: TransactionItem[] | null = repo.SortedTransactions(null, true);
	let bucketNodes = useSelector((state: any) => state.bucketNodes.value);
	const budgets: BudgetItem[] = repo.GetBudgetTree();
	const users: UserItem[] = useSelector((state: any) => state.users.value);
	const savedReports: SavedReport[] = useSelector((state: any) => state.savedReports.value);

	if (!FamilyHasAccess(user, Features.Reports)) {
		navigate("/");
		return <></>;
	}

	return (
		<>
			<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
				<h2 className="mt-2 text-app">Reports</h2>
				{(transactions == null || bucketNodes == null) && (
					<Typography variant="body2" component="p"><em>Loading...</em></Typography>
				)}
			</Box>
			{(transactions != null && bucketNodes != null) && (
				<Grid container spacing={2}>
					<Grid item xs={12} md={6} lg={4}>
						<Card variant="outlined">
							<CardHeader avatar={<FileEarmarkSpreadsheetFill />} title="My Activity" />
							<CardContent>
								<Stack direction="row" spacing={2}>
									<Button variant="contained" onClick={() => OpenMyReport(false)}>Spending</Button>
									<Button variant="outlined" onClick={() => OpenMyReport(true)}>Mileage</Button>
								</Stack>
							</CardContent>
						</Card>
					</Grid>

					{user.isHoH && (
						<>
							<Grid item xs={12} md={6} lg={4}>
								<Card variant="outlined">
									<CardHeader avatar={<FileEarmarkSpreadsheetFill />} title="By Budget" />
									<CardContent>
										<Stack direction="row" spacing={2}>
											<Button variant="contained" onClick={() => OpenOverallReport(false)}>Spending</Button>
											<Button variant="outlined" onClick={() => OpenOverallReport(true)}>Mileage</Button>
										</Stack>
									</CardContent>
								</Card>
							</Grid>

							<Grid item xs={12} md={6} lg={4}>
								<Card variant="outlined">
									<CardHeader avatar={<FileEarmarkSpreadsheetFill />} title="By User" />
									<CardContent>
										<Stack direction="row" spacing={2}>
											<Button variant="contained" onClick={() => OpenUsersReport(false)}>Spending</Button>
											<Button variant="outlined" onClick={() => OpenUsersReport(true)}>Mileage</Button>
										</Stack>
									</CardContent>
								</Card>
							</Grid>
						</>
					)}

					{!isMobile &&
					<Grid item xs={12} lg={8}>
						<Card variant="outlined">
							<CardHeader title="Custom Reports" />
							<CardContent>
								<Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 2 }}>
									<Button variant="contained" onClick={() => navigate('/reports/custom')} startIcon={<FileEarmarkSpreadsheetFill />}>Custom Report Builder</Button>
								</Stack>
								{savedReports && savedReports.length > 0 ? (
									<>
										<Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>Saved Reports</Typography>
										<List dense disablePadding>
											{savedReports.map((r) => (
												<>
													<ListItemButton key={r.id} onClick={() => navigate(`/reports/custom?reportId=${r.id}`)}>
														<ListItemIcon>
															<FileEarmarkSpreadsheetFill />
														</ListItemIcon>
														<ListItemText
															primary={r.name}
															secondary={`Last modified ${dayjs(r.modified).format('MMM D, YYYY h:mm A')}`}
														/>
													</ListItemButton>
													<Divider component="li" />
												</>
											))}
										</List>
									</>
								) : (
									<Typography variant="body2" color="text.secondary">No saved reports yet.</Typography>
								)}
							</CardContent>
						</Card>
						<Card variant="outlined" className="mt-3">
							<CardHeader title="Annual Budget Breakdown" />
							<CardContent>
								<Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 2 }}>
									<Button variant="outlined" onClick={() => navigate('/reports/prorata')} startIcon={<FileEarmarkSpreadsheetFill />}>View</Button>
								</Stack>
							</CardContent>
						</Card>
					</Grid>
					}
				</Grid>
			)}
		</>
	);

	function HideModal() {
		dispatch(setProps({ ...modal, IsOpen: false }));
	}

	function OpenOverallReport(isMileage: boolean) {
		const newModal = {
			...modal,
			Body: <ExpensesReport IsMileage={isMileage} Budgets={budgets} BucketNodes={bucketNodes} Transactions={transactions} User={user} StartDate={new DateTime().addDays(-30)} EndDate={new DateTime()} ViewReport={ViewBudgetReport} Close={HideModal} />,
			IsOpen: true,
			WasOpen: false
		};
		dispatch(setProps(newModal));
	}

	function OpenUsersReport(isMileage: boolean) {
		const newModal = {
			...modal,
			Body: <UserReport IsMileage={isMileage} Users={users} Budgets={budgets} BucketNodes={bucketNodes} Transactions={transactions} User={user} StartDate={new DateTime().addDays(-30)} EndDate={new DateTime()} ViewReport={ViewUserReport} Close={HideModal} />,
			IsOpen: true,
			WasOpen: false
		};
		dispatch(setProps(newModal));
	}

	function OpenMyReport(isMileage: boolean) {
		const newModal = {
			...modal,
			Body: <UserReport IsMileage={isMileage} Users={users.filter(u => u.isMe)} Budgets={budgets} BucketNodes={bucketNodes} Transactions={transactions} User={user} StartDate={new DateTime().addDays(-30)} EndDate={new DateTime()} ViewReport={ViewUserReport} IsMe={true} Close={HideModal} />,
			IsOpen: true,
			WasOpen: false
		};
		dispatch(setProps(newModal));
	}

	function ViewBudgetReport() {
		HideModal();
		navigate("/report/budgets");
	}

	function ViewUserReport() {
		HideModal();
		navigate("/report/users");
	}
}

export default Reports;